import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { HaSurveyserviceService } from '../../services/HaSurvey.service';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';
import { ErrorModel } from '../../../../shared/models/Error.model';

@Component({
  selector: 'app-ha-surveymanagementdisplay',
  templateUrl: './ha-surveymanagementdisplay.component.html',
  styleUrls: ['./ha-surveymanagementdisplay.component.css']
})

export class HaSurveymanagementdisplayComponent implements OnInit {
  surveyId: string;
  showOverlaySurveyDisplay: boolean;
  surveyDetail: any[];
  completedSurveyDetail: any[];
  name: any;
  reason: any;
  totalQuestions: any;
  sharedPatients: any;
  surveyCompletedCounts: any;
  createdOn;
  surveyData: any;
  indexPat: number = 1;
  mainViewError = new ErrorModel();

  constructor(private _route: ActivatedRoute, private router: Router, private _service: HaSurveyserviceService) {}

  ngOnInit() {
    this.indexPat = 1;
    this._route.queryParams.subscribe(params => {
      this.surveyId = params['Survey_Id']
    });
    this._route.queryParams.subscribe(params => {
      this.name = params['Name']
    });
    this._route.queryParams.subscribe(params => {
      this.reason = params['Reason']
    });
    this._route.queryParams.subscribe(params => {
      this.totalQuestions = params['totalQuestions']
    });
    this._route.queryParams.subscribe(params => {
      this.sharedPatients = params['sharedPatients']
    });
    this._route.queryParams.subscribe(params => {
      this.surveyCompletedCounts = params['SurveyCompletedCounts']
    });
    this._route.queryParams.subscribe(params => {
      this.createdOn = params['createdOn']
    });

    this.getSharedPatientsOfSurvey();
    this.alterDiv(this.indexPat);
  }

getSharedPatientsOfSurvey() {

  this.showOverlaySurveyDisplay = true;
  this.mainViewError.display = false;
  this._service.getSharePatientsOfSelectedSurvey(this.surveyId).subscribe(
  (data: any[]) => {
    this.surveyDetail = data;
    if (this.surveyDetail !== undefined && this.surveyDetail !== null && this.surveyDetail.length > 0) {
      this.completedSurveyDetail = this.surveyDetail.filter(survey => survey.surveyIsCompleted == true);
    }
    this.getSurveyQuestions();
  },
  (error) => {
    this.mainViewError.error = error;
    this.mainViewError.display = true;
  }).add(() => {
    this.showOverlaySurveyDisplay = false;
  });
}

getSurveyQuestions() {
  this.mainViewError.display = false;
  this._service.getAllHaSurveysQuestions(this.surveyId).subscribe(
    (data: any) => {
      this.surveyData = data;
    },
    (error) => {
      AlertMessages.Show('Failed','Could not load all data!',AlertType.Error);
      this.mainViewError.error = error;
      this.mainViewError.display = true;
    }).add(() => {
      this.showOverlaySurveyDisplay = false;
    });
}



  alterDiv(index) {
    this.indexPat = index;
  }

  routeback() {
    this.router.navigate(['Hospital/HAAdmin/HaSurveymain'], {
      queryParams: {}
    });
  }

  deleteSurvey() {
    const res = confirm('Are you sure you want to delete this survey');
    if (res == true) {
      this._service.deleteSurveyPaper(this.surveyId).subscribe((data) => {
        this.alertCloseSurvey();
        AlertMessages.Show('Deleted', 'Survey Deleted!', AlertType.Success);
      },
      (error) => {
        AlertMessages.Show('Failed', 'Could not delete!', AlertType.Error);
      });
    }
  }

  alertCloseSurvey() {
    setTimeout(() => {
      this.router.navigate(['Hospital/HAAdmin/HaSurveymain'], {
        queryParams: {}
      });
    }, 1000);
  }

  // deleteParticularQuestion(SurveyQuestionId) {
  //   const res = confirm('Are you sure you want to delete this question');
  //   if (res == true) {
  //     this._service.deleteSurveyPaperQuestion(this.surveyId, SurveyQuestionId).subscribe(
  //     (data) => {
  //       console.log(data);
  //       if (data["Id"] == 1) {
  //         AlertMessages.Show('Deleted', 'Question Deleted!', AlertType.Error);
  //         this.surveyDetail.splice(this.surveyDetail.findIndex(i => i.Id == SurveyQuestionId), 1);
  //         this.totalQuestions = parseInt(this.totalQuestions) - 1;
  //       } else {
  //         AlertMessages.Show('Success', data["StatusMessage"], AlertType.Success);
  //       }
  //     },
  //     (error) => {
  //       AlertMessages.Show('Failed', 'Question:not deleted!', AlertType.Error);
  //     });
  //   }
  // }

  goToSurvey(Linkcode) {
     const url = 'SurveyViaLink?LinkCode=' + Linkcode.trim();
    window.open(url, '_blank');
  }

}
